import { widgetMixin } from './widgetMixin'

export const longScopeMixin = function (autoReload = false) {
  return {
    data() {
      return {
        scopes: {
          days: {
            description: 'Days',
            info: 'Statistics for the past 7 days'
          },
          weeks: {
            description: 'Weeks',
            info: 'Statistics for the past 7 weeks'
          },
          months: {
            description: 'Months',
            info: 'Statistics for the past 7 months'
          },
          years: {
            description: 'Years',
            info: 'Statistics for the past 7 years'
          }
        },
        scopeForm: {
          scope: 'days'
        }
      }
    },
    computed: {
      selectedScope() {
        if (this.scopeForm.scope) {
          return this.scopes[this.scopeForm.scope]
        }
        return {}
      }
    },
    methods: {
      doSelectScope(scope, reload = true) {
        if (this.scopes[scope]) {
          this.scopeForm.scope = scope
          if (reload) {
            this.doReload()
          }
        }
      }
    },
    mixins: [
      widgetMixin(autoReload)
    ]
  }
}
